module.exports = __webpack_public_path__ + "static/Gerda-tablet-11d01ff099f928a5501eecc78a92600f.jpg";